import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DeviceDetailPageRoutingModule } from './device-detail-routing.module';

import { DeviceDetailPage } from './device-detail.page';
import { TranslateModule } from '@ngx-translate/core';
import { HtmlWithStylePipe } from 'src/app/pipes/htmlWithStyle/html-with-style.pipe';
import { ParseHtmlPipe } from 'src/app/pipes/parseHtml.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    DeviceDetailPageRoutingModule,
    TranslateModule
  ],
  declarations: [DeviceDetailPage, HtmlWithStylePipe, ParseHtmlPipe]
})
export class DeviceDetailPageModule {}
